// Product cards (Design System v3, components.md: Product card): on devices with a real hover,
// fade in the first worn/model photo over the flat lay. Flat lays and detail shots are skipped by
// their alt text or file name. Styles: assets/pb-system.css v3 layer "Product card hover".
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const skip = /flat|detail|construction/i;

  const prepare = (card) => {
    if (card.dataset.pbHover) return;
    card.dataset.pbHover = 'none';
    const gallery = card.querySelector('.card-gallery');
    const slot = gallery?.querySelector(':scope > a.contents') || gallery?.firstElementChild;
    const images = Array.from(card.querySelectorAll('.product-media__image'));
    const model = images.find((img) => !skip.test(`${img.alt || ''} ${img.getAttribute('src') || ''}`));
    if (!gallery || !slot || !model || model === images[0]) return;
    const overlay = document.createElement('img');
    overlay.className = 'pb-card-hover';
    overlay.alt = '';
    overlay.decoding = 'async';
    if (model.getAttribute('srcset')) overlay.srcset = model.getAttribute('srcset');
    overlay.sizes = images[0].sizes || model.sizes || '25vw';
    overlay.src = model.getAttribute('src');
    overlay.addEventListener('load', () => overlay.classList.add('is-ready'), {once: true});
    slot.after(overlay);
    card.dataset.pbHover = 'ready';
  };

  // Prepare on first approach, so the photo is usually loaded by the time the pointer settles.
  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest?.('product-card');
    if (card) prepare(card);
  }, {passive: true});
})();
